<template>
  <SideMenuItem
    :item="item" :collapsed="collapsed"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <template #icon>
      <font-awesome-icon
        class="fa-fw"
        icon="circle"
        transform="right-2"
        :style="{ color: statusColor }"
      />
    </template>
  </SideMenuItem>

  <SideMenuTooltip ref="tooltipRefDriverStatus" :collapsed="collapsed"/>

  <driver-status-dialog
    v-model:visible="dialogIsOpen"
    :drivers="drivers"
    :error="error"
  />
</template>

<script lang="ts">
import CompanyApi from '@/data/companies/CompanyApi.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import Colors from '@/infrastructure/support/Colors.ts';
import DriverStatusDialog from '@/presentation/components/mainmenu/DriverStatusDialog.vue';
import type { MenuItem } from '@/presentation/components/mainmenu/MenuItem.ts';
import SideMenuItem from '@/presentation/components/mainmenu/SideMenuItem.vue';
import SideMenuTooltip from '@/presentation/components/mainmenu/SideMenuTooltip.vue';

export default {
  name: 'MainMenuDriverStatus',
  components: { SideMenuTooltip, SideMenuItem, DriverStatusDialog },
  props: {
    collapsed: { type: Boolean },
  },
  data() {
    return {
      company: useSessionStore().company,
      status: null,
      drivers: [],
      dialogIsOpen: false,
      error: false,
      item: {
        translation: {
          key: 'features.main_menu_driver_status.unavailable',
          params: {},
        },
        clickClosure: () => this.openDialog(),
      } as MenuItem,
    };
  },
  mounted() {
    this.error = false;
    this.status = null;
    this.drivers = [];

    this.item.translation = {
      key: 'features.main_menu_driver_status.unavailable',
      params: {},
    };

    new CompanyApi()
      .forwardToErrorPageOnException(false)
      .driverStatus(this.company.id)
      .then((response) => {
        if (response.data[0].message) {
          this.error = true;
          return;
        }
        const data = response.data[0];
        this.status = data.status;

        const key =
          this.status > 0
            ? 'features.main_menu_driver_status.degraded'
            : 'features.main_menu_driver_status.ok';

        this.item.translation = {
          key: key,
          params: {},
        };
        this.drivers = data.drivers;
      })
      .catch(() => (this.error = true));
  },
  methods: {
    openDialog() {
      this.dialogIsOpen = true;
    },
    showTooltip(event: MouseEvent) {
      (
        this.$refs.tooltipRefDriverStatus as InstanceType<
          typeof SideMenuTooltip
        >
      )?.onEnter(event, this.item);
    },
    hideTooltip() {
      (
        this.$refs.tooltipRefDriverStatus as InstanceType<
          typeof SideMenuTooltip
        >
      )?.onLeave();
    },
  },
  computed: {
    statusColor() {
      if (this.status === null) return Colors.colorByStatus('NONE');
      return Colors.colorByStatus(this.status > 0 ? 'MEDIUM' : 'OK');
    },
  },
};
</script>
